import React, { useEffect, useState } from "react";
import {
  Upload,
  Button,
  Form,
  Input,
  message,
  Select,
  Spin,
  Tag,
  Space,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import CropperUploder from "../../imageUploader/CropperUploder";

import { State, City } from "country-state-city";
import { createManager, updateManager } from "../../../api/AdminRequest";
import { Link, useNavigate } from "react-router-dom";

const { Option } = Select;

const CreateManager = ({ editData }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imgPre, setImgPre] = useState("");
  const [loader, setLoader] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  console.log(selectedStates);

  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [stateSearchValue, setStateSearchValue] = useState("");
  const [citySearchValue, setCitySearchValue] = useState("");


  useEffect(() => {
    setStates(State.getStatesOfCountry("IN"));
  }, []);
  useEffect(() => {
    const fetchManager = async () => {


      const manager = editData;
      form.setFieldsValue({
        name: manager.name,
        email: manager.email,
        role: manager.roleDetails.role,
        phone: manager.phone || "",
        state: manager.roleDetails.state,
        district: manager.roleDetails.district,
        city: manager.roleDetails.city,
      });

      // Set selected states, districts, and cities
      setSelectedStates(
        manager.roleDetails.state
          .map((stateCode) => states.find((s) => s.isoCode === stateCode))
          .filter(Boolean)
      );

      setSelectedDistrict(
        manager.roleDetails.district.map((districtName) => ({
          name: districtName.split("-")[1],
          stateCode: districtName.split("-")[0],
        }))
      );

      setSelectedCities(
        manager.roleDetails.city.map((cityName) => ({
          name: cityName.split("-")[1],
          stateCode: cityName.split("-")[0],
        }))
      );

      // Update cities based on selected states
      const allCities = manager.roleDetails.state.flatMap((stateCode) =>
        City.getCitiesOfState("IN", stateCode).map((city) => ({
          ...city,
          stateCode: stateCode,
        }))
      );
      setCities(allCities);

      if (manager.roleDetails.profileImage) {
        setFileList([
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: manager.roleDetails.profileImage,
          },
        ]);
        setImgPre(manager.profileImage);
      }
    }



    if (editData) { fetchManager() }
  }, [editData, form, states]);

  const handleSubmit = async (values) => {
    // console.log(values, "sasasasa");

    try {
      setLoader(true);
      // console.log(fileList, "fileList");

      const formData = new FormData();

      // Log the form values for debugging
      // console.log("Form values:", values);

      // Add basic fields
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("phone", values.phone || "");
      formData.append("address", values.address || "");

      // Handle role (could be string or array)
      if (Array.isArray(values.role)) {
        values.role.forEach((role) => formData.append("role[]", role));
      } else {
        formData.append("role[]", values.role);
      }

      // Add state, district, and city
      values.state.forEach((state) => formData.append("state[]", state));
      values.district.forEach((district) =>
        formData.append("district[]", district)
      );
      values.city.forEach((city) => formData.append("city[]", city));

      // Add profile image if present
      if (fileList[0]?.originFileObj) {
        formData.append("profileImg", fileList[0].originFileObj);
      }

      // Log the FormData for debugging
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }


      const { data } = await editData ? updateManager(editData._id, formData) : createManager(formData);


      console.log("API Response:", data);

      if (data?.success) {
        message.success("Manager Created Successfully")
        navigate('/manager-list')
      } else {
        message.error(data?.message || "Failed to process request");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      message.error(
        error.message || "An error occurred while processing your request"
      );
    } finally {
      setLoader(false);
    }
  };

  // ----------- PROFILE IMAGE-------------

  const handleDataFromChild = (data, base64Img) => {
    const imgSelected = [
      {
        uid: "-1",
        name: "image.png",
        status: data ? "done" : "",
        url: base64Img,
        thumbUrl: base64Img,
        originFileObj: data,
      },
    ];
    setFileList(imgSelected);
    setImgPre(base64Img);
  };

  const onChange = ({ fileList: newFileList }) => {
    if (newFileList[0]?.status) {
      newFileList[0].status = "done";
    }
    setFileList(newFileList);
    setImgPre(
      newFileList[0]?.originFileObj
        ? URL.createObjectURL(newFileList[0]?.originFileObj)
        : ""
    );
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleStateChange = (value) => {
    const selectedStateObjects = states.filter((state) =>
      value.includes(state.isoCode)
    );
    setSelectedStates(selectedStateObjects);
    const allCities = selectedStateObjects.flatMap((state) =>
      City.getCitiesOfState("IN", state.isoCode).map((city) => ({
        ...city,
        stateCode: state.isoCode,
      }))
    );
    setCities(allCities);
    setSelectedCities([]);
  };

  const handleCityChange = (value) => {
    const selectedCityObjects = cities.filter((city) =>
      value.includes(`${city.stateCode}-${city.name}`)
    );
    setSelectedCities(selectedCityObjects);
  };
  const handleDistrictChange = (value) => {
    const selectedCityObjects = cities.filter((city) =>
      value.includes(`${city.stateCode}-${city.name}`)
    );
    setSelectedDistrict(selectedCityObjects);
  };

  const removeState = (stateToRemove) => {
    setSelectedStates(
      selectedStates?.filter((state) => state.isoCode !== stateToRemove.isoCode)
    );
    setSelectedCities(
      selectedCities.filter((city) => city.stateCode !== stateToRemove.isoCode)
    );
    form.setFieldsValue({
      state: selectedStates
        .filter((state) => state.isoCode !== stateToRemove.isoCode)
        .map((s) => s.isoCode),
      city: selectedCities
        .filter((city) => city.stateCode !== stateToRemove.isoCode)
        .map((c) => `${c.stateCode}-${c.name}`),
    });
  };

  const removeCity = (cityToRemove) => {
    setSelectedCities(
      selectedCities.filter(
        (city) =>
          !(
            city.name === cityToRemove.name &&
            city.stateCode === cityToRemove.stateCode
          )
      )
    );
    form.setFieldsValue({
      city: selectedCities
        .filter(
          (city) =>
            !(
              city.name === cityToRemove.name &&
              city.stateCode === cityToRemove.stateCode
            )
        )
        .map((c) => `${c.stateCode}-${c.name}`),
    });
  };
  const removeDistrict = (districtToRemove) => {
    setSelectedCities(
      selectedCities.filter(
        (city) =>
          !(
            city.name === districtToRemove.name &&
            city.stateCode === districtToRemove.stateCode
          )
      )
    );
    form.setFieldsValue({
      district: selectedCities
        .filter(
          (city) =>
            !(
              city.name === districtToRemove.name &&
              city.stateCode === districtToRemove.stateCode
            )
        )
        .map((c) => `${c.stateCode}-${c.name}`),
    });
  };
  const filterStates = (input, option) =>
    option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;

  const filterCities = (input, option) =>
    option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;

  const handleStateSearch = (value) => {
    setStateSearchValue(value);
  };

  const handleCitySearch = (value) => {
    setCitySearchValue(value);
  };
  // Group cities by state
  const groupedCities = cities.reduce((acc, city) => {
    if (!acc[city.stateCode]) {
      acc[city.stateCode] = [];
    }
    acc[city.stateCode].push(city);
    return acc;
  }, {});
  const uploderButton = (
    <div className="flex flex-col items-center justify-center w-[200px] h-[150px] border border-dashed border-[#A3BBFF] rounded-md">
      <PlusOutlined style={{ fontSize: "32px", color: "#A3BBFF" }} />
      <p className="mt-2 text-[18px] font-medium text-[#313131]">Upload</p>
    </div>
  );


  return (
    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <div>
        <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white"></div>

        <Spin spinning={loader}>
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"

          >
            <div className=" flex items-center justify-center mb-4 lg:mb-0">
              {fileList?.length !== 0 ? (
                <Upload
                  listType="picture-card"
                  fileList={fileList}
                  onChange={onChange}
                  onPreview={onPreview}
                >
                  {fileList?.length < 1 && uploderButton}
                </Upload>
              ) : (
                <div className="w-full h-full">
                  <CropperUploder
                    onDataFromChild={handleDataFromChild}
                    uploderButton={uploderButton}
                    identifier={"profileImage"}
                  />
                </div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:w-2/3 gap-4">
              <div>
                <h2 className="text-lg font-semibold mb-4">Basic Details</h2>
                <Form.Item
                  name="name"
                  label="Full Name"
                  rules={[
                    { required: true, message: "Please enter Full name" },
                    {
                      min: 2,
                      message: "Name must be at least 2 characters long",
                    },
                    { max: 50, message: "Name cannot exceed 50 characters" },
                  ]}
                >
                  <Input className="h-10 rounded-md" />
                </Form.Item>

                <Form.Item
                  name="email"
                  label="Email Id"
                  rules={[
                    { required: true, message: "Please enter email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input className="h-10 rounded-md" disabled={editData} />
                </Form.Item>
                {!editData && (
                  <Form.Item
                    name="password"
                    label="password"
                    rules={[
                      { required: true, message: "Please enter password" },
                      {
                        type: "password",
                        message: "Please enter a valid email",
                      },
                    ]}
                  >
                    <Input className="h-10 rounded-md" />
                  </Form.Item>
                )}

                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter a phone number",
                    },
                    {
                      pattern: /^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/,
                      message: "Please enter a valid Indian phone number",
                    },
                    {
                      min: 10,
                      max: 14,
                      message: "Phone number must be between 10 and 14 digits",
                    },
                  ]}
                  normalize={(value) => {
                    // Remove any non-digit characters
                    return value.replace(/[^\d]/g, "");
                  }}
                >
                  <Input
                    className="h-10 rounded-md"
                    placeholder="Enter 10-digit number or with country code"
                  />
                </Form.Item>
              </div>

              <div>
                <h2 className="text-lg font-semibold mb-4">Daily Permission</h2>
                <Form.Item
                  name="role"
                  label="role"
                  className="role-1"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one role!",
                    },
                  ]}
                >
                  <Select
                    className="border-[#A3BBFF] text-[#4A4A4C] text-sm font-medium h-10"
                    placeholder="Select roles"
                  >
                    <Option value="Survey Requests">Survey Requests</Option>
                    <Option value="Manager">Manager</Option>
                    {/* Add more role options as needed */}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="state"
                  label="State"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one state",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select States"
                    onChange={handleStateChange}
                    className="h-10 rounded-md"
                    value={selectedStates?.map((state) => state.isoCode)}
                    filterOption={filterStates}
                    onSearch={handleStateSearch}
                    showSearch
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    maxTagCount={3}
                    maxTagTextLength={10}
                  >
                    {states
                      .filter((state) =>
                        state.name
                          .toLowerCase()
                          .includes(stateSearchValue.toLowerCase())
                      )
                      .slice(0, 50) // Limit to first 50 matching results
                      .map((state) => (
                        <Option key={state.isoCode} value={state.isoCode}>
                          {state.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                <Space size={[0, 8]} wrap>
                  {selectedStates?.map((state) => (
                    <Tag
                      key={state.isoCode}
                      closable
                      onClose={() => removeState(state)}
                      style={{ marginBottom: 8 }}
                    >
                      {state.name}
                    </Tag>
                  ))}
                </Space>

                <Form.Item
                  name="district"
                  label="district name"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one district",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select district"
                    onChange={handleDistrictChange}
                    className="h-10 rounded-md"
                    disabled={selectedStates?.length === 0}
                    value={selectedCities.map(
                      (city) => `${city.stateCode}-${city.name}`
                    )}
                    filterOption={filterCities}
                    onSearch={handleCitySearch}
                    showSearch
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    maxTagCount={3}
                    maxTagTextLength={10}
                  >
                    {Object.entries(groupedCities)
                      .filter(([stateCode, _]) =>
                        selectedStates?.some((s) => s.isoCode === stateCode)
                      )
                      .map(([stateCode, stateCities]) => {
                        const stateName =
                          selectedStates?.find((s) => s.isoCode === stateCode)
                            ?.name || "";
                        return (
                          <Select.OptGroup key={stateCode} label={stateName}>
                            {stateCities
                              .filter((city) =>
                                city.name
                                  .toLowerCase()
                                  .includes(citySearchValue.toLowerCase())
                              )
                              .slice(0, 20) // Limit to first 20 matching results per state
                              .map((city) => (
                                <Option
                                  key={`${city.stateCode}-${city.name}`}
                                  value={`${city.stateCode}-${city.name}`}
                                >
                                  {city.name}
                                </Option>
                              ))}
                          </Select.OptGroup>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Space size={[0, 8]} wrap>
                  {selectedDistrict.map((city) => (
                    <Tag
                      key={`${city.stateCode}-${city.name}`}
                      closable
                      onClose={() => removeDistrict(city)}
                      style={{ marginBottom: 8 }}
                    >
                      {city.name}
                    </Tag>
                  ))}
                </Space>

                <Form.Item
                  name="city"
                  label="City"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one city",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select Cities"
                    onChange={handleCityChange}
                    className="h-10 rounded-md"
                    disabled={selectedStates?.length === 0}
                    value={selectedCities.map(
                      (city) => `${city.stateCode}-${city.name}`
                    )}
                    filterOption={filterCities}
                    onSearch={handleCitySearch}
                    showSearch
                    optionFilterProp="children"
                    style={{ width: "100%" }}
                    maxTagCount={3}
                    maxTagTextLength={10}
                  >
                    {Object.entries(groupedCities)
                      .filter(([stateCode, _]) =>
                        selectedStates?.some((s) => s.isoCode === stateCode)
                      )
                      .map(([stateCode, stateCities]) => {
                        const stateName =
                          selectedStates?.find((s) => s.isoCode === stateCode)
                            ?.name || "";
                        return (
                          <Select.OptGroup key={stateCode} label={stateName}>
                            {stateCities
                              .filter((city) =>
                                city.name
                                  .toLowerCase()
                                  .includes(citySearchValue.toLowerCase())
                              )
                              .slice(0, 20) // Limit to first 20 matching results per state
                              .map((city) => (
                                <Option
                                  key={`${city.stateCode}-${city.name}`}
                                  value={`${city.stateCode}-${city.name}`}
                                >
                                  {city.name}
                                </Option>
                              ))}
                          </Select.OptGroup>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Space size={[0, 8]} wrap>
                  {selectedCities.map((city) => (
                    <Tag
                      key={`${city.stateCode}-${city.name}`}
                      closable
                      onClose={() => removeCity(city)}
                      style={{ marginBottom: 8 }}
                    >
                      {city.name}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>

            <div className="mt-6 flex flex-col md:flex-row md:space-x-4">
              <Link
                to='/manager-list'
                className="w-full md:w-1/2 h-10 border font-semibold border-[#313131] text-[#313131] rounded-lg text-sm md:text-base"
              >
                Discard
              </Link>
              <Button
                type="primary"
                htmlType="submit"
                className="mt-4 md:mt-0 w-full md:w-1/2 h-10 text-white text-sm md:text-base font-semibold rounded-lg flex align-middle "
              >
                {editData ? "Update" : "Create"}
              </Button>
            </div>
          </Form>
        </Spin>


      </div>
    </div>
  );
};

export default CreateManager;
